import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Slide from '@material-ui/core/Slide';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Link } from "../../elements";
import styles from "./TextBlock.module.scss";

const useStyles = makeStyles((theme) => ({


    root: {
        textAlign: "justify",
        border: "0em",
        outline: "none",
        background: "#f1f1f1",
        width: "50%",
        padding: "1em 4em 0em 4em",
        letterSpacing: "2px",
        borderRadius: "2em",
        height: 'fit-content',
        overflow: 'auto',
        position: "absolute",
        margin: 'auto',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        [theme.breakpoints.down('md')]: {
            width: '80%',
            letterSpacing: '1px',
            padding: "1em 2.5em 0em 2.5em",
            height: '90%'
        },
        heading: {
            letterSpacing: "2px",
            paddingBottom: "2rem",
            fontWeight: "700",
            [theme.breakpoints.down('md')]: {
                fontSize: "24px",
                fontWeight: "700",
            },
        },
        paragraph: {
            textAlign: "justify",
            border: "5px solid #f05a28",
            borderRadius: '2em',
            padding: "1em",
            [theme.breakpoints.down('md')]: {
                fontSize: "16px",
            },
        },
        // left: "25%"
    }
}))

export default function More(props) {
    const classes = useStyles();

    const infoarray = [
        {
            title: "Vysion Technology",
            info: "Vysion Technology is a technology startup incubated by the Gujarat government under the SSIP initiative. The startup team comprises young and skilled enthusiasts from IITs, NITs, and IIITs working and innovating tirelessly in trendy terrains of IoT, Artificial Intelligence, Mobile/Web Applications, and Cloud. We deliver a series of smart solutions in different sectors where the Nation is still lagging to establish it's feet; like environment conservation, clean and efficient renewable energy production, digital education, and smart infrastructures for cities and technology driven industries. Our vision is to empower the nation by providing simple solutions to complex problems that would empower India in becoming the World Leader. We envision in innovating and eradicating the bottlenecks in sectors of preserving the environment, efficient usage of renewable energy, accomplishing superior infrastructure, and Digital Literacy. The nation is challenged and demands immediate solutions to strike its roots to rise against odds. We aim to deliver smarter and affordable solutions to build a better architecture of the future India, where the cities and industries are thorough smart and green and digital education is flourishing.",
            link: 'http://www.techvysion.com/',
        },
        {
            title: "KasperTech",
            info: "Passion is the key essence of a true entrepreneur. Following their passion for technology and the zeal to integrate it to make lives better, the team of four engineers from IIIT Surat came together envisioning in creating safer ecosystem through technology, leading to KasperTech. KasperTech is an urban automation startup incubated at Gujarat University Startup And Entrepreneurship Council (GUSEC). We endeavor in creating smart services for homes, offices and automobiles. Our vision is to bring automation technology to every corner of business economically striving for safety while building a Futuristic Present. As technology becomes further integrated into our everyday lives we creating a range of products and services aimed at making our surroundings safer, more efficient and more connected than ever before. We aim at impacting lives by bringing together people, systems and solutions seamlessly.On the busy chaotic roads of India, almost everything can be found except discipline and fear of law. There are several dimensions for safety and discipline on roads.  These include automotive components, road engineering including leveraging vehicle data management, connectivity, driving apps and dark spot identifications. Too much emphasis in recent times has been on prevention of road accident through traffic rules, but what about the aftermath. Road accident statistics show that fatalities can be prevented if timely medical aid is provided .Here Kaspertech’s new product comes into play as the first respondent at the accident site. The real reform on the roads will be brought about by immediate measures using new technology.After adequate market research on safety through automation, we found out that it was a growing industry with a lot of potential and increasing awareness in India, but there are only few products in the Indian market that too from foreign companies. We have developed the prototype for the product and are hoping for a successful launch.",
            link: 'https://www.thekaspertech.com/',
        }
    ]

    return (
        <div style={{ overflow: "hidden", }}>
            <Modal
                open={props.modal}
                onClose={props.handleClose}
                aria-labelledby="modal-title"
                border="none"
            >
                <Slide direction="down" in={props.modal} mountOnEnter unmountOnExit style={{ textAlign: "center" }}>

                    <Grid className={classes.root}>
                        <div style={{ border: '3px solid #000', borderRadius: '2em', padding: '1em', marginTop: '2em' }}>
                            <Typography variant="h2" justify="start" className={classes.heading}>
                                {infoarray[props.info].title}
                            </Typography>
                            <Typography variant="h5" className={classes.paragraph}>
                                {infoarray[props.info].info}
                            </Typography>
                        </div>
                        <div style={{ margin: '1em' }}>
                            <a href={infoarray[props.info].link} target='_blank' className={styles.link}>Visit Website</a>
                        </div>
                    </Grid>

                </Slide>
            </Modal>
        </div>
    );
}